import React from 'react';
import loadable from '@loadable/component';
import preventDirectServerAccess from 'helpers/preventDirectServerAccess';

const Landing = loadable(() => import('./Landing'));
const Purchase = loadable(() => import('./PurchaseContainer'));
const Payment = loadable(() => import('./PaymentContainer'));
const Confirmation = loadable(() => import('./ConfirmationContainer'));

const onEnter = preventDirectServerAccess('/gifts/purchase');

export const GiftingRoute = () => ({
  path: '/gifts',
  indexRoute: {
    component: props => <Landing {...props} />,
  },
  childRoutes: [
    { path: 'purchase', component: props => <Purchase {...props} /> },
    { path: 'purchase/payment', component: props => <Payment {...props} />, onEnter },
    { path: 'purchase/confirmation', component: props => <Confirmation {...props} />, onEnter },
  ],
});
